<div class="row">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-blue">
          <div class="card-header">
            <div class="row">
              <div class="col-8">
                <h6 class="card-title">Tipo Documentos do Cliente</h6>
              </div>
              <div class="col-4 text-right">
                <button (click)="showModal()" class="btn btn-block btn-primary text-right" style="margin-top: 5px;"><i class="fa fa-plus"></i></button>
              </div>
            </div>
          </div>
          <div class="card-body table-responsive p-0" >
            <table  class="table table-hover table-borderless table-head-fixed table-striped text-nowrap">
              <thead >
              <tr>
                <th>Descrição</th>
                <th style="width: 20px">*</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let linha of listaDocumento | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
                <td>{{linha.descricao}}</td>
                <td><button (click)="desativar(linha.id)"  class="btn btn-danger"><i class="fa fa-minus"></i></button></td>
              </tr>
              <tr *ngIf="listaDocumento.length == 0">
                <td colspan="10" class="text-center text-blue">Nenhum registro a ser mostrado</td>
              </tr>
              </tbody>
              <tfoot>
              <tr class="text-center">
                <td [attr.colspan]="3">
                  <pagination-controls class="pagination-sm"
                                       [autoHide]="false"
                                       [directionLinks]="true"
                                       previousLabel="Anterior"
                                       nextLabel="Próximo"
                                       (pageChange)="pageChange($event)">
                  </pagination-controls>
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="adicionar"
     class="modalTabela" id="modalPastas"
     role="dialog" aria-labelledby="modalPastasLabel"
     aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalPastasTitulo">Novo tipo documento do cliente</h5>
        <button type="button" (click)="fecharModal()"
                class="close" data-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <hr class="col-md-11" style="margin-left: 20px">
      <div class="modal-body">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="descricao">Descrição</label>
                <input type="text" class="form-control" name="descricao" id="descricao"
                       [(ngModel)]="tipoDocumentoCliente.descricao" placeholder="Digite a descrição">
              </div>
            </div>
            <div class="col-md-12 text-center">
              <button class="btn btn-primary col-md-6" (click)="salvar()">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
